import { Tabs } from "@mantine/core";
import { SystemEmailsTab } from "../../../hooks/admin/useSystemEmailsPage";
import { HeldEmailQueuePanel } from "./HeldEmailQueuePanel";
import { SystemEmailCataloguePanel } from "./SystemEmailCataloguePanel";

interface Props {
  active: SystemEmailsTab;
  onChange: (value: string | null) => void;
}

export function SystemEmailsTabs({ active, onChange }: Props) {
  return (
    <Tabs value={active} onChange={onChange}>
      <Tabs.List>
        <Tabs.Tab value="registry">Email catalogue</Tabs.Tab>
        <Tabs.Tab value="queue">Pending emails</Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel value="registry" pt="lg">
        <SystemEmailCataloguePanel />
      </Tabs.Panel>
      <Tabs.Panel value="queue" pt="lg">
        <HeldEmailQueuePanel />
      </Tabs.Panel>
    </Tabs>
  );
}
